// Utils
import { isMultiSelectListItemSelected } from '../utils/multi-select-list-utils';
import * as i0 from "@angular/core";
/**
 * Is Multi Select List Item Selected Pipe
 *
 * Checks if an item in the MultiSelectListComponent is currently selected.
 */
export class isMultiSelectListItemLevelsSelectedPipe {
    transform(item, selectedItems, activeSecurityGroupTab) {
        return isMultiSelectListItemSelected(item, selectedItems, activeSecurityGroupTab);
    }
}
isMultiSelectListItemLevelsSelectedPipe.ɵfac = function isMultiSelectListItemLevelsSelectedPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || isMultiSelectListItemLevelsSelectedPipe)(); };
isMultiSelectListItemLevelsSelectedPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "isMultiSelectListItemLevelsSelected", type: isMultiSelectListItemLevelsSelectedPipe, pure: true, standalone: false });
